class MobileLayoutController extends HTMLElement {
  constructor() {
    super();
    this.breakpoint = 768;
  }

  connectedCallback() {
    this.grid = document.querySelector('.main-products-grid');
    if (this.grid) {
      this.setInitialLayout();
      this.handleResize = this.handleResize.bind(this);
      window.addEventListener('resize', this.handleResize);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  setInitialLayout() {
    const isMobile = window.innerWidth < this.breakpoint;
    this.grid.dataset.layout = isMobile ? 'list' : 'grid';
    this.grid.classList.add('layout-initialized');
  }

  handleResize() {
    const isMobile = window.innerWidth < this.breakpoint;
    const currentLayout = this.grid.dataset.layout;

    if (isMobile && currentLayout !== 'list') {
      this.grid.dataset.layout = 'list';
    } else if (!isMobile && currentLayout === 'list') {
      const savedLayout = theme.storageUtil?.get('products-layout') || 'grid';
      this.grid.dataset.layout = savedLayout;
    }
  }
}

if (!customElements.get('mobile-layout-controller')) {
  customElements.define('mobile-layout-controller', MobileLayoutController);
}